/**
 * @file: dateFromValue.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { isValidDate } from '@euler/utils/datetime/isValidDate';
import toDate from 'date-fns/toDate';
import { Platform } from 'react-native';

const isWeb = Platform.OS === 'web';

export const dateFromString = (s: string) =>
  isWeb
    ? new Date(s.endsWith('Z') || s.includes('T') ? s : s.replace(/-/g, '/'))
    : new Date(s);

export const dateFromValue = (
  value: string | number | Date | null | undefined,
  dateOnly?: boolean,
  defaultDate?: Date,
) => {
  // eslint-disable-next-line @typescript-eslint/init-declarations
  let date: Date;

  if (value == null) {
    date = defaultDate ?? new Date();
  } else if (typeof value === 'string') {
    date = dateFromString(value);
    if (!isValidDate(date)) {
      date = defaultDate ?? new Date();
    }
  } else {
    date = toDate(value);
  }

  if (dateOnly) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  return date;
};

export const maybeDateFromValue = (
  value: string | number | Date | null | undefined,
  dateOnly?: boolean,
) => {
  if (value == null) {
    return null;
  }

  let date: Date | null = null;

  if (typeof value === 'string') {
    date = dateFromString(value);
  } else {
    date = toDate(value);
  }

  if (!isValidDate(date)) {
    return null;
  }

  if (dateOnly) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  return date;
};
